import { Anchor } from '@mantine/core';

const typeConfig = {
  g: { 
    description: "Carrera de Grado/Pregrado (Presencial y Distancia)", 
    shortDescription: "Carrera de Grado/Pregrado",
    minRegistrants: '20',
    confirmationRequiredDocumentation: (
      <> 
        Para finalizar el trámite de matriculación deberá presentar la documentación requerida en los{' '}
        <Anchor href="https://uai.edu.ar/media/134351/requisitos-de-ingreso-pregrado-y-grado-2.pdf" target="_blank" underline="hover" c="#f20a61">Requisitos de Ingreso a la Universidad</Anchor>
        {' '}y efectuar el correspondiente pago de matrícula.
      </>
    ),
  },
  p: { 
    description: "Carrera de Posgrado", 
    shortDescription: "Carrera de Posgrado",
    minRegistrants: '20',
    confirmationRequiredDocumentation: (
      <> 
        Para finalizar el trámite de matriculación deberá presentar la documentación requerida en los{' '}
        <Anchor href="https://uai.edu.ar/media/134351/requisitos-de-ingreso-pregrado-y-grado-2.pdf" target="_blank" underline="hover" c="#f20a61">Requisitos de Ingreso a la Universidad</Anchor>
        {' '}y efectuar el correspondiente pago de matrícula.
      </>
    ),
  },
  e: { 
    description: "Diplomatura, Curso o Evento", 
    shortDescription: "Diplomatura, Curso o Evento",
    minRegistrants: '20',
    confirmationRequiredDocumentation: (
      <> 
        Para finalizar el trámite de matriculación deberá presentar la documentación requerida y efectuar el correspondiente pago de matrícula.
      </>
    ),
  },
  m: { 
    description: "Microcredencial", 
    shortDescription: "Microcredencial",
    minRegistrants: '15',
    confirmationRequiredDocumentation: (
      <> 
        Para finalizar el trámite de matriculación deberá presentar la documentación requerida y efectuar el correspondiente pago de matrícula.
      </>
    ),
  },
};

export default typeConfig;